function getBaseDomain(host = window.location.hostname) {
  // ts.net is on the public suffix list so browsers will drop cookies scoped to its hostnames
  if (host.toLowerCase().endsWith('.ts.net')) return null;

  if (!host.includes('.')) {
    return host; // localhost
  }

  const [domain, extension] = host.split('.').slice(-2);
  return `${domain}.${extension}`;
}

interface CookieOptions {
  days?: number;
  domainSpecific?: true;
}

export function createCookie(name: string, value: string, options?: CookieOptions) {
  let cookie = `${name}=${value}`;

  if (typeof options?.days === 'number' && Number.isInteger(options.days)) {
    const date = new Date();
    date.setTime(date.getTime() + options.days * 24 * 60 * 60 * 1000);

    cookie += `; expires=${date.toUTCString()}`;
  }

  cookie += '; path=/;';

  const baseDomain = options?.domainSpecific === true ? null : getBaseDomain();
  if (baseDomain) {
    cookie += `; domain=${baseDomain}`;
  }

  document.cookie = cookie;
}

// Based on code from https://www.quirksmode.org/js/cookies.html
export function readCookie(name: string) {
  const nameEq = `${name}=`;

  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.startsWith(' ')) {
      c = c.substring(1, c.length);
    }

    if (c.startsWith(nameEq)) {
      return c.substring(nameEq.length, c.length);
    }
  }

  return null;
}

export function eraseCookie(name: string, options?: CookieOptions) {
  createCookie(name, '', { ...options, days: -1 });
}
